<!--
* 组件名 : 左侧关闭按钮+分享
* 开发者 : HN
*
* 参数:  无
*
* 事件:  null
*
-->
<template>
  <div class="menu-right">
    <v-btn
      class="menu-close"
      ref="menuClose"
      :linear="true"
      color="#ffffff"
      @btnClick="updateIsShowAside"
    >
      <v-icon>close</v-icon>
    </v-btn>
    <div class="menu-share" v-if="shareShow">
      <div class="contact-us">
        <a
          v-for="item in followUs"
          :key="item.name"
          :href="item.link"
          target="_blank"
        >
          <img :src="item.imgLink" :alt="item.name" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { getDomainUrl } from "@/utils/ajax";
export default {
  name: "menu-right",

  data() {
    return {
      followUs: [],
      shareShow: false,
    };
  },
  async mounted() {
    let apiData = await this.get_contact_us_data();
    this.followUs = apiData.item && apiData.item.socialPlatforms.data;
    // 生成分享按钮
    window.setTimeout(() => {
      this.shareShow = true;
    }, 1500);
  },
  methods: {
    ...mapMutations("global", ["updateIsShowAside"]),
    /**
     * 获取联系我们平台数据
     */
    get_contact_us_data() {
      let ajaxUrl = getDomainUrl("website-general-data", "application-data");

      return new Promise((res, rej) => {
        $.get(ajaxUrl)
          .then((data) => {
            res(data);
          })
          .catch((err) => rej(err));
      });
    },
  },
};
</script>

<style lang="scss">
#menu {
  .menu-container {
    .menu-right {
      position: absolute;
      top: 0;
      left: 40px;
      width: 48px;
      height: 100vh;
      opacity: 0;
      transform: translateX(-1vw);
      transition: all 500ms cubic-bezier(0.645, 0.045, 0.355, 1);

      transition-delay: 250ms;
      .menu-close {
        position: absolute;
        top: 24px;
        left: 0;

        i {
          color: #fff;
        }
        .borderCircle {
          border: 1px solid rgba(255, 255, 255, 0.8);
        }
      }
      .menu-share {
        position: absolute;
        bottom: 27px;
        left: 0;
        width: 100%;

        .contact-us {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-right: auto;
          width: 36px;

          a {
            padding: 9px 0;
            transition: transform 0.3s;

            img {
              max-width: 100%;
            }

            &:hover {
              transform: scale(1.08);
            }
          }
        }
      }
    }
  }
}
</style>
